import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "wc-atc-button-modern" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 4,
  class: "wc-atc-button-modern__multi-ot wc-atc-button-modern__multi-ot--label"
}
const _hoisted_6 = { class: "wc-atc-button-modern__multi-ot-label" }
const _hoisted_7 = { class: "wc-atc-button-modern__multi-ot-label-text" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = {
  key: 6,
  class: "wc-atc-button-modern__multi-ot"
}
const _hoisted_10 = { class: "wc-atc-button-modern__multi-ot-add" }
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = {
  key: 7,
  class: "wc-atc-button-modern__action"
}

import { computed, toRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { BTN_VARIANT as ATLB_BTN_VARIANT } from '@/constants/AppConstants';
import useCartControls from '@/composables/useCartControls';
import useOrderTypes from '@/composables/useOrderTypes';
import useMultiOTPicker from '@/modules/orderTypes/composables/useMultiOTPicker';
import WCAddToListModernCardButton from '@/modules/lists/components/WCAddToListModernCardButton/WCAddToListModernCardButton.vue';
import ItemSummary from '@/models/entities/items/item-summary';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCAddToCartModernCardButton',
  props: {
    item: {},
    linkButtonType: { type: Boolean, default: false },
    addToListVariant: { default: ATLB_BTN_VARIANT.ATC as keyof typeof ATLB_BTN_VARIANT }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const { isInStock, isInStoreOnly, isNotAvailable } = useCartControls();
const { isItemListOnly, isAcoMode } = useOrderTypes();
const {
  hasMultiOTPicker,
  requiresOtherOTConfirmation,
  cardState,
  otherOrderTypesWithQuantity,
  openPicker,
} = useMultiOTPicker(toRef(props, 'item'));

const notAvailable = computed(() => isNotAvailable(props.item));

const outOfStock = computed(
  () => !notAvailable.value && !isInStock(props.item) && !isInStoreOnly(props.item),
);

const inStoreOnly = computed(() => !notAvailable.value && isInStoreOnly(props.item));

const isMto = computed(() => Boolean(props.item.hasModifiers || props.item.hasLinkedItems));

const onPlainAddClick = (event: Event): void => {
  event.stopPropagation();
  event.preventDefault();
  openPicker();
};

const inOtherCartLabel = computed(() => {
  if (cardState.value === 'inOtherCart') {
    const orderTypeName = otherOrderTypesWithQuantity.value[0]?.orderType?.name ?? '';
    return t('inOrderTypeCart', { orderTypeName });
  }
  return t('inOtherOrderTypeCarts');
});

const listOnly = computed(() => isItemListOnly(props.item) && !isAcoMode.value);

const addToListInferredVariant = computed(() => {
  if (props.linkButtonType) {
    return ATLB_BTN_VARIANT.LINK;
  }

  return props.addToListVariant;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (listOnly.value && !isMto.value)
      ? (_openBlock(), _createBlock(WCAddToListModernCardButton, {
          key: 0,
          class: "wc-atc-button-modern__action",
          item: _ctx.item,
          btnVariant: addToListInferredVariant.value
        }, null, 8, ["item", "btnVariant"]))
      : (notAvailable.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            id: `atc-not-available-${_ctx.item.id}`,
            type: "button",
            class: "wc-atc-button-modern__pill",
            disabled: ""
          }, _toDisplayString(_unref(t)('notAvailable')), 9, _hoisted_2))
        : (outOfStock.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              id: `atc-out-of-stock-${_ctx.item.id}`,
              type: "button",
              class: "wc-atc-button-modern__pill",
              disabled: ""
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'ban'],
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)('outOfStock')), 1)
            ], 8, _hoisted_3))
          : (inStoreOnly.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                id: `atc-in-store-only-${_ctx.item.id}`,
                type: "button",
                class: "wc-atc-button-modern__pill",
                disabled: ""
              }, _toDisplayString(_unref(t)('inStoreOnly')), 9, _hoisted_4))
            : (_unref(cardState) === 'inOtherCart' || _unref(cardState) === 'inOtherCarts')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'check'],
                      "aria-hidden": "true"
                    }),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(inOtherCartLabel.value), 1)
                  ]),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _createElementVNode("button", {
                    type: "button",
                    class: "wc-atc-button-modern__multi-ot-caret",
                    "aria-label": _unref(t)('chooseCart'),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(openPicker)()), ["stop"]))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'ellipsis-vertical'],
                      "aria-hidden": "true"
                    })
                  ], 8, _hoisted_8)
                ]))
              : ((_unref(hasMultiOTPicker) && _unref(cardState) === 'plainBase') || _unref(requiresOtherOTConfirmation))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: "wc-atc-button-modern__action",
                    onClickCapture: onPlainAddClick
                  }, [
                    _renderSlot(_ctx.$slots, "default")
                  ], 32))
                : (_unref(hasMultiOTPicker))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _renderSlot(_ctx.$slots, "default")
                      ]),
                      _cache[4] || (_cache[4] = _createTextVNode()),
                      _createElementVNode("button", {
                        type: "button",
                        class: "wc-atc-button-modern__multi-ot-caret",
                        "aria-label": _unref(t)('chooseCart'),
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(openPicker)()), ["stop"]))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fas', 'ellipsis-vertical'],
                          "aria-hidden": "true"
                        })
                      ], 8, _hoisted_11)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _renderSlot(_ctx.$slots, "default")
                    ]))
  ]))
}
}

})